import React from "react";
import { InputAnswerAreaForLetters } from "./StyledComponent";
import TextSpeachWriteInNumber from "../TextSpeachWriteInNumber";

// JSON.parse protégé : une consigne non-JSON ne doit pas crasher le rendu.
const safeParse = (v) => { try { return JSON.parse(v); } catch { return null; } };

const NumberDictation = ({ item, consigneValues, setConsigneValues, handleAddWord }) => {
    return (
        <div className="flex flex-col items-center gap-10 pt-16">
            <TextSpeachWriteInNumber text={item?.consigne?.map((c) => safeParse(c)?.value || c)} />
            {item?.consigne?.map((_, index) => (
                <InputAnswerAreaForLetters
                    key={index}
                    value={consigneValues[index]?.userValue || ""}
                    placeholder="Votre réponse"
                    onChange={(e) => {
                        const updatedValues = [...consigneValues];
                        updatedValues[index] = { ...updatedValues[index], userValue: e.target.value };
                        setConsigneValues(updatedValues);
                    }}
                // onBlur={(e) => handleAddWord(e.target.value)}
                />
            ))}
        </div>
    );
};

export default NumberDictation;
